import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../../hooks/useNotifaction";
import { createContractTerms, getContractTermById, updateContractTerm } from "../../../redux/contractSlice/contractSlice";

export default function AddContractTerms() {
  const location = useLocation();
  const { error, status, detailsContractTerm } = useSelector((state) => state.contract);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [contractTermsData, setContractTermsData] = useState({
    title: "",
    description: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(getContractTermById(id));
    }
  }, [id]);
  useEffect(() => {
    if (detailsContractTerm && id) {
      setContractTermsData(detailsContractTerm);
    }
  }, [detailsContractTerm, id]);

  const validateForm = () => {
    let tempErrors = {};
    if (!contractTermsData.title.trim()) {
      tempErrors.title = "عنوان البند مطلوب";
    } else if (contractTermsData.title.length < 3) {
      tempErrors.title = "العنوان يجب أن يكون 3 أحرف على الأقل";
    }

    if (!contractTermsData.description.trim()) {
      tempErrors.description = "الوصف مطلوب";
    } else if (contractTermsData.description.length < 10) {
      tempErrors.description = "الوصف يجب أن يكون 10 أحرف على الأقل";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (name, value) => {
    const sanitizedValue = value.trimStart().replace(/  +/g, " ");
    setContractTermsData((prev) => ({
      ...prev,
      [name]: sanitizedValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  async function handleForm(e) {
    e.preventDefault();
    if (!validateForm()) {
      notify("يرجى ملء جميع الحقول المطلوبة بشكل صحيح", "error");
      return;
    }

    setLoading(true);
    try {
      if (!id) {
        await dispatch(createContractTerms(contractTermsData)).unwrap();
      } else {
        await dispatch(updateContractTerm({ id, data: contractTermsData })).unwrap();
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (!loading) {
      if (status === "succeeded") {
        if (id) {
          notify("تم التحديث بنجاح", "success");
        } else {
          notify("تم اضافة شرط العقد بنجاح", "success");
        }
        navigate("/allContractTerms");
        setContractTermsData({
          title: "",
          description: "",
        });
        setErrors({});
      } else if (status === "failed") {
        notify(error?.message || "حدث خطأ أثناء الإضافة", "error");
      }
      setLoading(false);
    }
  }, [status, loading, error]);

  return (
    <div className="main">
      <h2 className="text-white mb-4">اضافة شرط العقد</h2>
      <form onSubmit={handleForm} noValidate>
        <div className="card mb-3 pt-5 pb-2 px-3 companyProfile">
          <section className="row mb-5">
            <h4>
              <span>شروط العقد</span>
            </h4>
            <div className="col-12 mt-3 mb-2">
              <div>
                <label htmlFor="title">العنوان</label>
                <input type="text" value={contractTermsData.title} onChange={(e) => handleChange("title", e.target.value)} placeholder="عنوان البند" id="title" className={`form-control ${errors.title ? "is-invalid" : ""}`} />
                {errors.title && <div className="invalid-feedback">{errors.title}</div>}
              </div>
            </div>
            <div className="col-12 mt-3 mb-2">
              <div>
                <label htmlFor="description">البند</label>
                <textarea value={contractTermsData.description} onChange={(e) => handleChange("description", e.target.value)} placeholder=" البند" id="description" className={`form-control ${errors.description ? "is-invalid" : ""}`} />
                {errors.description && <div className="invalid-feedback">{errors.description}</div>}
              </div>
            </div>
          </section>
          <div>
            <button type="submit" className="btn btn-primary">
              {!loading ? <span className="spinner-border spinner-border-sm me-1" /> : <i className="fas fa-plus me-1"></i>}
              {id ? "تعديل" : "اضافة"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
